import { render, staticRenderFns } from "./DataAnalysisIndex.vue?vue&type=template&id=6b27a77e&scoped=true&"
import script from "./DataAnalysisIndex.vue?vue&type=script&lang=js&"
export * from "./DataAnalysisIndex.vue?vue&type=script&lang=js&"
import style0 from "./DataAnalysisIndex.vue?vue&type=style&index=0&id=6b27a77e&lang=scss&scoped=true&"
import style1 from "./DataAnalysisIndex.vue?vue&type=style&index=1&id=6b27a77e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b27a77e",
  null
  
)

export default component.exports